import script from "./AnalysisHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnalysisHistory.vue?vue&type=script&setup=true&lang=ts"

import "./AnalysisHistory.vue?vue&type=style&index=0&id=626b8338&lang=scss"

const __exports__ = script;

export default __exports__